import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ClickToCopyDirective } from '../../_directives/click-to-copy.directive';
import { HrefPreventDefaultDirective } from '../../_directives/href-prevent-default.directive';
import { UnwrapTagDirective } from '../../_directives/unwrap-tag.directive';
import { HeaderComponent } from '../../components/header/header.component';
import { ImageViewerComponent } from '../../components/imageViewer/imageViewer.component';
import { PlaceholderComponent } from '../../components/placeholder/placeholder.component';
import { StickyChatComponent } from '../../components/sticky-chat/sticky-chat.component';
import { DefaultComponent } from '../pages/default/default.component';
import { DefaultPortalComponent } from '../../portalV2/default/default.component';
// tslint:disable-next-line:max-line-length
import { LoaderEnabledEnabledTypeSpinnerMessageComponent } from '../pages/loader-enabled-enabled-type-spinner-message/loader-enabled-enabled-type-spinner-message.component';
import { AsideNavComponent } from './aside-nav/aside-nav.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderNavComponent } from './header-nav/header-nav.component';
import { QuickSidebarComponent } from './quick-sidebar/quick-sidebar.component';
import { ScrollTopComponent } from './scroll-top/scroll-top.component';
import { TooltipsComponent } from './tooltips/tooltips.component';

import { HeaderPortalComponent } from '../../portalV2/common/header/header.component';
@NgModule({
  declarations: [
    DefaultComponent,
    DefaultPortalComponent,
    HeaderNavComponent,
    AsideNavComponent,
    LoaderEnabledEnabledTypeSpinnerMessageComponent,
    FooterComponent,
    QuickSidebarComponent,
    ScrollTopComponent,
    TooltipsComponent,
    HrefPreventDefaultDirective,
    ClickToCopyDirective,
    UnwrapTagDirective,
    StickyChatComponent,
    ImageViewerComponent,
    PlaceholderComponent,
    HeaderComponent,
    HeaderPortalComponent
  ],
  exports: [
    RatingModule,
    DefaultComponent,
    DefaultPortalComponent,
    HeaderNavComponent,
    AsideNavComponent,
    LoaderEnabledEnabledTypeSpinnerMessageComponent,
    FooterComponent,
    QuickSidebarComponent,
    ScrollTopComponent,
    TooltipsComponent,
    HrefPreventDefaultDirective,
    ClickToCopyDirective,
    StickyChatComponent,
    ImageViewerComponent,
    PlaceholderComponent,
    HeaderComponent,
    HeaderPortalComponent
  ],
  imports: [
    RatingModule.forRoot(),
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    TooltipModule.forRoot()
  ]
})
export class LayoutModule {}



// WEBPACK FOOTER //
// ./src/app/theme/layouts/layout.module.ts